module.exports = __webpack_public_path__ + "img/katarina_events_6.11ecedbd.jpg";